var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect } from "react";
import { getClients } from "../actions/clients";
import Header from "../components/layout/Header";
import { checkGoogleConnectionFull, checkFacebookConnectionFull, handleGoogleLogin, handleGoogleLoginMobile, handleFacebookLogin, handleFacebookLoginMobile, logoutGoogle, logoutFacebook, } from "../actions/platforms";
import { getAgencyName } from "../actions/users";
import GeneralSettings from "../components/client/GeneralSettings";
import AdAccountLogin from "../components/client/AdAccountLogin";
import ClientTable from "../components/client/ClientTable";
import { useLoadingWithSnakeModal } from "../hooks/useLoadingWithSnakeModal";
import { trackQualifiedLead } from "../utils/tracking";
var Config = function () {
    var _a = useState([]), clients = _a[0], setClients = _a[1];
    var _b = useState(""), newClientName = _b[0], setNewClientName = _b[1];
    var _c = useState([]), googleAccounts = _c[0], setGoogleAccounts = _c[1];
    var _d = useState([]), facebookAccounts = _d[0], setFacebookAccounts = _d[1];
    var _e = useState([]), instagramAccounts = _e[0], setInstagramAccounts = _e[1];
    var _f = useState(false), loadingGoogleAccounts = _f[0], setLoadingGoogleAccounts = _f[1];
    var _g = useState(false), loadingFacebookAccounts = _g[0], setLoadingFacebookAccounts = _g[1];
    var _h = useState(false), loadingInstagramAccounts = _h[0], setLoadingInstagramAccounts = _h[1];
    var _j = useState(30), refreshInterval = _j[0], setRefreshInterval = _j[1];
    var _k = useState(false), isGoogleConnected = _k[0], setIsGoogleConnected = _k[1];
    var _l = useState(false), loadingGoogleConnection = _l[0], setLoadingGoogleConnection = _l[1];
    var _m = useState(false), isFacebookConnected = _m[0], setIsFacebookConnected = _m[1];
    var _o = useState(true), loadingFacebookConnection = _o[0], setLoadingFacebookConnection = _o[1];
    var _p = useState({}), currentUserAgency = _p[0], setCurrentUserAgency = _p[1];
    var _q = useState(null), facebookUserName = _q[0], setFacebookUserName = _q[1];
    var _r = useState(null), facebookUserPicture = _r[0], setFacebookUserPicture = _r[1];
    var _s = useState(null), googleUserName = _s[0], setGoogleUserName = _s[1];
    var _t = useState(null), googleUserPicture = _t[0], setGoogleUserPicture = _t[1];
    var _u = useState(false), showTutorial = _u[0], setShowTutorial = _u[1];
    // ✅ Snake Modal com tempo reduzido
    var _v = useLoadingWithSnakeModal(3000), showSnakeModal = _v.showSnakeModal, runWithSnakeModal = _v.runWithSnakeModal; // 3 segundos
    var fetchClients = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getClients()];
                case 1:
                    response = _a.sent();
                    setClients(response.data.map(function (client) { return (__assign(__assign({}, client), { google: client.google_customer_id || null, facebook: client.fb_account_id || null, instagram: client.instagram_account_id || null })); }));
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error("Erro ao buscar clientes:", error_1);
                    setClients([]);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleFinishTutorial = function () {
        // Lógica extra ao finalizar o tutorial, se necessário
    };
    // ✅ GOOGLE ADS - OTIMIZADO (1 requisição)
    var checkGoogleConnectionStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoadingGoogleConnection(true);
                    setLoadingGoogleAccounts(true);
                    return [4 /*yield*/, runWithSnakeModal(function () { return __awaiter(void 0, void 0, void 0, function () {
                            var response, _a, connected, accounts, profile, renewed, sortedAccounts, error_2;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        _b.trys.push([0, 2, 3, 4]);
                                        return [4 /*yield*/, checkGoogleConnectionFull()];
                                    case 1:
                                        response = _b.sent();
                                        _a = response.data, connected = _a.connected, accounts = _a.accounts, profile = _a.profile, renewed = _a.renewed;
                                        if (connected) {
                                            setIsGoogleConnected(true);
                                            // ✅ Perfil
                                            setGoogleUserName((profile === null || profile === void 0 ? void 0 : profile.name) || null);
                                            setGoogleUserPicture((profile === null || profile === void 0 ? void 0 : profile.photo) || null);
                                            sortedAccounts = (accounts || []).sort(function (a, b) {
                                                return a.name.localeCompare(b.name);
                                            });
                                            setGoogleAccounts(sortedAccounts);
                                            // ✅ Log
                                            // console.log(`✅ Google Ads conectado | Renovado: ${renewed} | Contas: ${accounts.length}`);
                                        }
                                        else {
                                            setIsGoogleConnected(false);
                                            setGoogleAccounts([]);
                                            setGoogleUserName(null);
                                            setGoogleUserPicture(null);
                                            if (response.data.action_required === "reconnect") {
                                                console.warn("⚠️ Token inválido, reconexão necessária");
                                            }
                                        }
                                        return [3 /*break*/, 4];
                                    case 2:
                                        error_2 = _b.sent();
                                        console.error("❌ Erro ao verificar Google Ads:", error_2);
                                        setIsGoogleConnected(false);
                                        setGoogleAccounts([]);
                                        setGoogleUserName(null);
                                        setGoogleUserPicture(null);
                                        return [3 /*break*/, 4];
                                    case 3:
                                        setLoadingGoogleConnection(false);
                                        setLoadingGoogleAccounts(false);
                                        return [7 /*endfinally*/];
                                    case 4: return [2 /*return*/];
                                }
                            });
                        }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    // ✅ FACEBOOK ADS - OTIMIZADO (1 requisição)
    var checkFacebookConnectionStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoadingFacebookConnection(true);
                    setLoadingFacebookAccounts(true);
                    setLoadingInstagramAccounts(true);
                    return [4 /*yield*/, runWithSnakeModal(function () { return __awaiter(void 0, void 0, void 0, function () {
                            var response, _a, connected, accounts, instagram_accounts, profile, renewed, days_until_expiry, sortedAccounts, sortedInstagram, error_3;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        _b.trys.push([0, 2, 3, 4]);
                                        return [4 /*yield*/, checkFacebookConnectionFull()];
                                    case 1:
                                        response = _b.sent();
                                        _a = response.data, connected = _a.connected, accounts = _a.accounts, instagram_accounts = _a.instagram_accounts, profile = _a.profile, renewed = _a.renewed, days_until_expiry = _a.days_until_expiry;
                                        if (connected) {
                                            setIsFacebookConnected(true);
                                            // ✅ Perfil
                                            setFacebookUserName((profile === null || profile === void 0 ? void 0 : profile.name) || null);
                                            setFacebookUserPicture((profile === null || profile === void 0 ? void 0 : profile.picture) || null);
                                            sortedAccounts = (accounts || []).sort(function (a, b) {
                                                return a.name.localeCompare(b.name);
                                            });
                                            setFacebookAccounts(sortedAccounts);
                                            sortedInstagram = (instagram_accounts || []).sort(function (a, b) {
                                                return a.instagram_username.localeCompare(b.instagram_username);
                                            });
                                            setInstagramAccounts(sortedInstagram);
                                            // ✅ Log
                                            // console.log(`✅ Facebook conectado | Renovado: ${renewed} | Expira em: ${days_until_expiry} dias`);
                                        }
                                        else {
                                            setIsFacebookConnected(false);
                                            setFacebookAccounts([]);
                                            setInstagramAccounts([]);
                                            setFacebookUserName(null);
                                            setFacebookUserPicture(null);
                                            if (response.data.action_required === "reconnect") {
                                                console.warn("⚠️ Token inválido, reconexão necessária");
                                            }
                                        }
                                        return [3 /*break*/, 4];
                                    case 2:
                                        error_3 = _b.sent();
                                        console.error("❌ Erro ao verificar Facebook Ads:", error_3);
                                        setIsFacebookConnected(false);
                                        setFacebookAccounts([]);
                                        setInstagramAccounts([]);
                                        setFacebookUserName(null);
                                        setFacebookUserPicture(null);
                                        return [3 /*break*/, 4];
                                    case 3:
                                        setLoadingFacebookConnection(false);
                                        setLoadingFacebookAccounts(false);
                                        setLoadingInstagramAccounts(false);
                                        return [7 /*endfinally*/];
                                    case 4: return [2 /*return*/];
                                }
                            });
                        }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchUserData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getAgencyName()];
                case 1:
                    response = _a.sent();
                    if (response) {
                        setCurrentUserAgency({ id: response.id, created_at: response.created_at });
                    }
                    else {
                        console.error("ID da agência não encontrado nos dados do usuário.");
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_4 = _a.sent();
                    console.error("Erro ao buscar dados do usuário:", error_4);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    // ✅ Carregamento inicial - AGORA EM PARALELO
    useEffect(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // Busca userData e clients sem snake modal
                    return [4 /*yield*/, Promise.all([
                            fetchUserData(),
                            fetchClients(),
                        ])];
                    case 1:
                        // Busca userData e clients sem snake modal
                        _a.sent();
                        // Busca plataformas em paralelo (cada uma com seu snake modal)
                        return [4 /*yield*/, Promise.all([
                                checkGoogleConnectionStatus(),
                                checkFacebookConnectionStatus(),
                            ])];
                    case 2:
                        // Busca plataformas em paralelo (cada uma com seu snake modal)
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        fetchData();
    }, []);
    useEffect(function () {
        function handleAuthSuccess(event) {
            var _a, _b;
            // ✅ GOOGLE AUTH
            if (((_a = event.data) === null || _a === void 0 ? void 0 : _a.type) === "google-auth-success") {
                checkGoogleConnectionStatus();
                var userData = event.data.userData;
                if (userData && userData.isFirstConnection) {
                    trackQualifiedLead({
                        email: userData.email,
                        firstName: userData.firstName,
                        lastName: userData.lastName,
                        userId: userData.userId
                    });
                }
            }
            // ✅ FACEBOOK AUTH (PRIORIDADE - dados do Facebook)
            if (((_b = event.data) === null || _b === void 0 ? void 0 : _b.type) === "facebook-auth-success") {
                checkFacebookConnectionStatus();
                var userData = event.data.userData;
                if (userData && userData.isFirstConnection) {
                    // 🔥 USAR DADOS DO FACEBOOK (melhor match)
                    trackQualifiedLead({
                        email: userData.email,
                        firstName: userData.firstName,
                        lastName: userData.lastName,
                        userId: userData.userId,
                        facebookId: userData.facebookId // 🔥 ID do Facebook
                    });
                }
            }
            // ✅ COMPATIBILIDADE COM CÓDIGO ANTIGO
            if (event.data === "google-auth-success") {
                checkGoogleConnectionStatus();
            }
            if (event.data === "facebook-auth-success") {
                checkFacebookConnectionStatus();
            }
        }
        window.addEventListener("message", handleAuthSuccess);
        return function () { return window.removeEventListener("message", handleAuthSuccess); };
    }, []);
    var handleClientDeleted = function (clientId) {
        setClients(function (prevClients) { return prevClients.filter(function (client) { return client.id !== clientId; }); });
    };
    var handleClientSaved = function (updatedClient) {
        setClients(function (prevClients) {
            return prevClients.map(function (client) {
                return client.id === updatedClient.id ? updatedClient : client;
            });
        });
    };
    var clientsSteps = [
        {
            target: ".tutorial-conectar-googleads",
            content: "Primeiro, conecte sua conta do Google Ads.",
            placement: "top",
            disableBeacon: true
        },
        {
            target: ".tutorial-conectar-facebookads",
            content: "Agora conecte sua conta do Facebook Ads.",
            placement: "top",
            disableBeacon: true
        },
        {
            target: ".tutorial-criar-cliente",
            content: "Digite o nome do seu primeiro cliente e clique em Incluir.",
            placement: "top",
            disableBeacon: true
        },
        {
            target: ".tutorial-vincular-contas-cliente",
            content: "Os clientes cadastrados aparecerão aqui. Para cada cliente, selecione as contas do Google Ads, Facebook Ads e Instagram e clique em 'Sincronizar contas'.",
            placement: "top",
            disableBeacon: true
        }
    ];
    useEffect(function () {
        // Só mostra o tutorial se não tiver clientes E não estiver conectado em nenhuma plataforma
        if (clients.length === 0 && !isGoogleConnected && !isFacebookConnected) {
            // Aguarda o elemento aparecer no DOM
            var interval_1 = setInterval(function () {
                if (document.querySelector('.tutorial-conectar-googleads')) {
                    setShowTutorial(true);
                    clearInterval(interval_1);
                }
            }, 100);
            return function () { return clearInterval(interval_1); };
        }
        else {
            setShowTutorial(false);
        }
    }, [clients, isGoogleConnected, isFacebookConnected]);
    return (React.createElement("div", { className: "h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black text-gray-100 flex flex-col overflow-x-hidden overflow-y-scroll scrollbar-grossa" },
        React.createElement(Header, { title: "Meus Clientes", isGoogleConnected: isGoogleConnected, isFacebookConnected: isFacebookConnected }),
        React.createElement("div", { className: "max-w-8xl mx-auto p-2 md:p-8 bg-gray-800/90 rounded-xl shadow-2xl" },
            React.createElement(GeneralSettings, { interval: refreshInterval, setInterval: setRefreshInterval }),
            React.createElement(AdAccountLogin, { isGoogleConnected: isGoogleConnected, loadingGoogleConnection: loadingGoogleConnection, handleGoogleLogin: handleGoogleLogin, handleGoogleLoginMobile: handleGoogleLoginMobile, handleGoogleLogout: function () { return __awaiter(void 0, void 0, void 0, function () {
                    var e_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 3, , 4]);
                                return [4 /*yield*/, logoutGoogle()];
                            case 1:
                                _a.sent();
                                setIsGoogleConnected(false);
                                setGoogleAccounts([]);
                                setGoogleUserName(null);
                                setGoogleUserPicture(null);
                                return [4 /*yield*/, checkGoogleConnectionStatus()];
                            case 2:
                                _a.sent();
                                return [3 /*break*/, 4];
                            case 3:
                                e_1 = _a.sent();
                                window.location.reload();
                                return [3 /*break*/, 4];
                            case 4: return [2 /*return*/];
                        }
                    });
                }); }, isFacebookConnected: isFacebookConnected, loadingFacebookConnection: loadingFacebookConnection, handleFacebookLogin: handleFacebookLogin, handleFacebookLoginMobile: handleFacebookLoginMobile, handleFacebookLogout: function () { return __awaiter(void 0, void 0, void 0, function () {
                    var e_2;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 3, , 4]);
                                return [4 /*yield*/, logoutFacebook()];
                            case 1:
                                _a.sent();
                                return [4 /*yield*/, checkFacebookConnectionStatus()];
                            case 2:
                                _a.sent();
                                return [3 /*break*/, 4];
                            case 3:
                                e_2 = _a.sent();
                                window.location.reload();
                                return [3 /*break*/, 4];
                            case 4: return [2 /*return*/];
                        }
                    });
                }); }, facebookUserName: facebookUserName, facebookUserPicture: facebookUserPicture, googleUserName: googleUserName, googleUserPicture: googleUserPicture }),
            (isGoogleConnected || isFacebookConnected) && (React.createElement(ClientTable, { clients: clients, isGoogleConnected: isGoogleConnected, isFacebookConnected: isFacebookConnected, googleAccounts: googleAccounts, facebookAccounts: facebookAccounts, loadingGoogleAccounts: loadingGoogleAccounts, loadingFacebookAccounts: loadingFacebookAccounts, loadingInstagramAccounts: loadingInstagramAccounts, setLoadingGoogleAccounts: setLoadingGoogleAccounts, setLoadingFacebookAccounts: setLoadingFacebookAccounts, setLoadingInstagramAccounts: setLoadingInstagramAccounts, agency: currentUserAgency, onClientDeleted: handleClientDeleted, onClientSaved: handleClientSaved, instagramAccounts: instagramAccounts })))));
};
export default Config;
